import React from "react";

import { useTheme, Box, Button, CircularProgress, Grid } from "@mui/material";

import { LocalizationProvider, DatePicker, MuiPickersAdapterContext } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";

const useStyles = (theme) => ({
    container: {
        display: "flex",
        alignItems: "center",
        flexDirection: "column",
        height: "10%",
        minHeight: "75px",
        minWidth: "520px",
        [theme.breakpoints.down("xl")]: {
            width: "80%",
        },
        [theme.breakpoints.down("lg")]: {
            width: "95%",
        },
    },
    dateSelectContainer: {
        width: "100%",
    },
    dateSelector: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "whitesmoke",
        borderRadius: "4px",
        border: "1px solid #e0e0e0",
    },
    dataRequestButton: {
        "&:hover": {
            cursor: "pointer",
        },
    },
});

export default function DateSelector(props) {
    const theme = useTheme();
    const classes = useStyles(theme);
    let {
        handleStartDateChange,
        handleEndDateChange,
        setOpenStart,
        setOpenEnd,
        openStart,
        openEnd,
        loading,
        startDateTime,
        endDateTime,
        handleDataFetch,
        data,
        startOfData,
        dateError,
        errorText,
        containerWidth,
    } = props;

    return (
        <Box component="div" sx={classes.container} style={{ width: containerWidth ?? "60%" }}>
            <Box component="div" sx={classes.dateSelectContainer}>
                <Grid item xs={12} md={12} lg={12} sx={classes.dateSelector}>
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <Grid item xs={5} md={5} lg={5}>
                            <DatePicker
                                open={openStart}
                                onOpen={() => setOpenStart(true)}
                                onClose={() => setOpenStart(false)}
                                variant="inline"
                                inputFormat="MMM dd, yyyy"
                                margin="normal"
                                id="date-picker-inline-start"
                                label="Start Date"
                                value={startDateTime}
                                onChange={handleStartDateChange}
                                error={dateError}
                                helperText={dateError ? errorText : ""}
                                orientation={"landscape"}
                                KeyboardButtonProps={{
                                    "aria-label": "change date",
                                }}
                                PopoverProps={{
                                    anchorOrigin: { horizontal: "right", vertical: "bottom" },
                                    transformOrigin: { horizontal: "left", vertical: "top" },
                                }}
                                style={{ width: "70%" }}
                            />
                        </Grid>

                        <Grid item xs={5} md={5} lg={5}>
                            <DatePicker
                                autoOk={false}
                                open={openEnd}
                                onOpen={() => setOpenEnd(true)}
                                onClose={() => setOpenEnd(false)}
                                variant="inline"
                                inputFormat="MMM dd, yyyy"
                                margin="normal"
                                id="date-picker-inline-end"
                                label="End Date"
                                value={endDateTime}
                                onChange={handleEndDateChange}
                                disableFuture={true}
                                error={dateError}
                                helperText={dateError ? errorText : ""}
                                PopoverProps={{
                                    anchorOrigin: { horizontal: "right", vertical: "bottom" },
                                    transformOrigin: { horizontal: "left", vertical: "top" },
                                }}
                                style={{ width: "70%" }}
                            />
                        </Grid>
                    </LocalizationProvider>
                    <Button
                        variant="contained"
                        color="primary"
                        size="small"
                        onClick={() => handleDataFetch(startDateTime, endDateTime, data, loading, startOfData)}
                        sx={classes.dataRequestButton}
                    >
                        Go
                    </Button>
                </Grid>
            </Box>

            {loading && <CircularProgress style={{ position: "relative", top: "25%", marginTop: "2rem" }} />}
        </Box>
    );
}
